

















import { TownModel } from '@/libs/Api';
import Page from '@/Page.vue';
import { Guid } from '@/libs/common/functions/guid';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { townsStore } from '@/libs/towns/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import TownDialog from '../components/TownDialog.vue';

@Component({
    components: {
        TownDialog
    }
})
export default class TownItems extends Page {

    @Prop() districtId!: string;

    @Ref() dialog!: TownDialog;

    get items(): TownModel[] {
        return [...townsStore.useGetter(CrudGetter.Data)]?.filter((e: TownModel) => {
            return e.districtId == this.districtId;
        }).sort((a: TownModel, b: TownModel) => {
            if(a.name! < b.name!) { return -1; }
            if(a.name! > b.name!) { return 1; }
            return 0;
        });
    }

    createItemClick () {
        this.dialog.open();
    }

    openItemClick (v: TownModel) {
        this.dialog.open(v.id);
    }

}
